import _ from 'lodash';
import { createReducer } from '../../../../common/reduxHelpers';
import * as types from './actionTypes';


export const initialState = {
    activePanelId: ['0'],
    list: [],
    isLoading: false,
    buttonEnabled: false,
    isPosting: false
}

const reducer = createReducer(initialState, {
    [types.FETCH_CONTACTS_SUCCESS](state, action) {
        return _.assign({}, state, {
            list: [...action.response],
            isLoading: false
        });
    },
    [types.FETCH_CONTACTS_REQUEST](state, action) {
        return _.assign({}, state, { isLoading: true });
    },
    [types.FETCH_CONTACTS_FAILURE](state, action) {
        return _.assign({}, state, {
            list: [],
            isLoading: false
        });
    },
    [types.CONTACT_SELECTED](state, action) {
        return _.assign({}, state, { selectedIndex: action.selectedIndex });
    },
    [types.CONTACT_SHIFT_LEFT](state, action) {
        const newIndex = state.selectedIndex > 0 ? state.selectedIndex - 1 : state.list.length - 1;
        return _.assign({}, state, { selectedIndex: newIndex });
    },
    [types.CONTACT_SHIFT_RIGHT](state, action) {
        const newIndex = state.selectedIndex < state.list.length - 1 ? state.selectedIndex + 1 : 0;
        return _.assign({}, state, { selectedIndex: newIndex });
    },
    [types.TOGGLE_PANEL](state, action) {
        const activePanelId = action.activePanelId[0] === "1" ? ["0"] : ["1"];
        return _.assign({}, state, { activePanelId });
    },
    [types.TOGGLE_BUTTON](state, action) {
        return {...state, buttonEnabled: action.buttonEnabled };
    },
    [types.SAVE_CONTACTS_REQUEST](state, action) {
        return {
            ...state,
            isPosting: true,
        };
    },
    [types.SAVE_CONTACTS_SUCCESS](state, action) {
        return {
            ...state,
            isPosting: false,
            isLoading: true,
            activePanelId: [state.activePanelId[0] === "1" ? "0" : "1"]
        };
    }
});

export default reducer;